module.exports = __webpack_public_path__ + "img/我的团队.6767d5dd.svg";